interface CheckboxProps {
  id: string;
  className?: string;
  onChange: (id: string) => void;
  checked: boolean;
  label?: string | null;
}

export default function Checkbox({
  id,
  className,
  onChange,
  checked,
  label,
}: CheckboxProps) {
  return (
    <>
      {label === null ? (
        <input
          id={`checkbox-${id}`}
          value={id}
          aria-describedby={`checkbox-${id}`}
          name={`checkbox-${id}`}
          type="checkbox"
          className={`h-4 w-4 rounded border-secondary-300 text-primary focus:ring-primary ${className}`}
          onChange={() => onChange(id)}
          checked={checked}
        />
      ) : (
        <div className="flex items-center">
          <input
            id={`checkbox-${id}`}
            value={id}
            aria-describedby={`checkbox-${id}`}
            name={`checkbox-${id}`}
            type="checkbox"
            className={`h-4 w-4 rounded border-secondary-300 text-primary focus:ring-primary ${className}`}
            onChange={() => onChange(id)}
            checked={checked}
          />
          <label
            htmlFor="comments"
            className="ml-3 text-sm text-black text-left"
          >
            {label}
          </label>
        </div>
      )}
    </>
  );
}

Checkbox.defaultProps = {
  className: "",
  label: null,
};
